import { render, staticRenderFns } from "./CandidateSettings.vue?vue&type=template&id=6d97f42a&scoped=true&"
import script from "./CandidateSettings.vue?vue&type=script&lang=js&"
export * from "./CandidateSettings.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSettings.vue?vue&type=style&index=0&id=6d97f42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97f42a",
  null
  
)

export default component.exports